



















































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import {
  Episode,
  Movie,
  Season,
  TvShow,
  VoDGenre
} from "@/services/apiService/api.types";
import { arrowKeysPreventDefault, scrollToPage } from "@/helpers/utils";
import SpatialNavigation from "spatial-navigation-js";
import { keyCodeFinder } from "@/services/keyCodeService/keyCodeService";
import { KeySet } from "@/services/keyCodeService/keyCode.types";
import { Getter, Mutation } from "vuex-class";
import { Namespace } from "@/store/types";
import {
  VodPageGetter,
  VodPageMutation,
  VoDType
} from "@/components/VoD/types";
import VoDCard from "@/components/VoD/component/VoDCard.vue";
import Swiper, { SwiperOptions } from "swiper";
import { EventBus } from "@/main";

@Component({
  components: { "vod-card": VoDCard }
})
export default class VodHome extends Vue {
  @Prop() readonly vodItem?: TvShow | Movie;
  @Prop() readonly isVodItemInPackage!: boolean;

  @Mutation(VodPageMutation.setPlayedEpisodePos, {
    namespace: Namespace.Vod
  })
  setPlayedEpisodePos!: (
    pos:
      | {
          slideIndex: number;
          sliderIndex: number;
        }
      | undefined
  ) => void;

  @Getter(VodPageGetter.GetViewedVodType, {
    namespace: Namespace.Vod
  })
  getViewedVodType?: VoDType;

  @Getter(VodPageGetter.GetTvShowsByGenre, {
    namespace: Namespace.Vod
  })
  getTvShowsByGenre!: VoDGenre[];

  @Getter(VodPageGetter.GetMoviesByGenre, {
    namespace: Namespace.Vod
  })
  getMoviesByGenre!: VoDGenre[];

  @Getter(VodPageGetter.GetCardControls, {
    namespace: Namespace.Vod
  })
  getCardControls!: boolean;

  @Getter(VodPageGetter.GetClosePlayer, { namespace: Namespace.Vod })
  getClosePlayer!: boolean;

  @Getter(VodPageGetter.GetPlayedEpisodePos, { namespace: Namespace.Vod })
  getPlayedEpisodePos!: { slideIndex: number; sliderIndex: number } | undefined;

  @Getter(VodPageGetter.GetShowEpisodeInfoModal, { namespace: Namespace.Vod })
  getShowEpisodeInfoModal!: boolean;

  genreSwipers: Swiper[] = [];
  activeSwiperIndex = 0; // determines active/focused swiper instance
  swiperActiveSlideIndexes: number[] = []; //indexes of active elements for each swiper - allows proper focusing when listing through swiper

  smallSwiper = false;

  swiperOptions: SwiperOptions = {
    keyboard: {
      enabled: false
    },
    slidesPerView: 5,
    spaceBetween: 20,
    breakpoints: {
      // when window width is <= 768px
      768: {
        slidesPerView: 3,
        spaceBetween: 10
      },
      1200: {
        slidesPerView: 5,
        spaceBetween: 20
      }
    }
  };

  VoDTypeRef = VoDType;

  scrollFuncRef = scrollToPage;

  created(): void {
    window.addEventListener("resize", () => {
      this.checkWindowWidth();
    });
    // setting initial status
    this.checkWindowWidth();
  }

  mounted(): void {
    this.initializeSwipers();
    EventBus.$on("focusExtraContent", () => {
      if (this.getPlayedEpisodePos !== undefined) {
        this.activeSwiperIndex = this.getPlayedEpisodePos.sliderIndex;
        this.swiperActiveSlideIndexes[this.activeSwiperIndex] =
          this.getPlayedEpisodePos.slideIndex;
        this.setPlayedEpisodePos(undefined);
      }
      //focus on active vodCard in the topmost swiper instance
      SpatialNavigation.pause();
      SpatialNavigation.focus(
        "#overlay" + this.activeSwiperIndex + this.swiperActiveSlideIndexes[0]
      );
      this.scrollFuncRef(
        "overlay" +
          this.activeSwiperIndex +
          this.swiperActiveSlideIndexes[this.activeSwiperIndex]
      );
    });
  }

  initializeSwipers(): void {
    //create all required swiper instances
    this.$nextTick(() => {
      //initializing extra content swipers
      for (let i = 0; i < this.displayedVodExtraContent.length; i++) {
        let categorySwiperInstance: Swiper;
        if (this.getViewedVodType === this.VoDTypeRef.Movies) {
          categorySwiperInstance = new Swiper(
            "#" +
              this.displayedVodExtraContent[i].name.replace(/\s/g, "") +
              "Overlay",
            this.swiperOptions
          );
        } else {
          categorySwiperInstance = new Swiper(
            "#" + this.displayedVodExtraContent[i].name.replace(/\s/g, ""),
            this.swiperOptions
          );
        }
        //setting coordinates for refocusing
        categorySwiperInstance.on("click", () => {
          this.swiperActiveSlideIndexes[i] =
            categorySwiperInstance.clickedIndex;
          this.activeSwiperIndex = i;
        });
        this.genreSwipers.push(categorySwiperInstance);
      }
      this.swiperActiveSlideIndexes = new Array(this.genreSwipers.length).fill(
        0
      );
    });
  }

  get activeSwiperInstance(): Swiper {
    return this.genreSwipers[this.activeSwiperIndex];
  }

  async handleVoDSimilarActions(event: KeyboardEvent): Promise<void> {
    if (!this.getCardControls && !this.getShowEpisodeInfoModal) {
      //preventing page scroll with arrow keys when card controls are selected
      arrowKeysPreventDefault(event);
      SpatialNavigation.pause();
      let activeSlide = this.swiperActiveSlideIndexes[this.activeSwiperIndex]; //index of active/focused slide of active swiper
      let swiperVodList: Episode[] | Movie[]; //array of items in active swiper
      swiperVodList = this.getVodList();
      switch (keyCodeFinder(event.keyCode)) {
        case KeySet.KEY_LEFT:
          if (
            (activeSlide >= 2 && activeSlide <= swiperVodList.length - 3) ||
            (this.smallSwiper &&
              activeSlide >= 1 &&
              activeSlide <= swiperVodList.length - 2)
          ) {
            this.activeSwiperInstance?.slidePrev();
          }

          if (activeSlide > 0)
            this.swiperActiveSlideIndexes[this.activeSwiperIndex]--;
          activeSlide--;
          SpatialNavigation.focus(
            "#overlay" +
              this.activeSwiperIndex +
              this.swiperActiveSlideIndexes[this.activeSwiperIndex]
          );

          break;
        case KeySet.KEY_RIGHT:
          if (
            (activeSlide >= 2 && activeSlide <= swiperVodList.length - 3) ||
            (this.smallSwiper &&
              activeSlide >= 1 &&
              activeSlide <= swiperVodList.length - 2)
          ) {
            this.activeSwiperInstance?.slideNext();
          }

          if (activeSlide < swiperVodList.length)
            this.swiperActiveSlideIndexes[this.activeSwiperIndex]++;
          activeSlide++;
          SpatialNavigation.focus(
            "#overlay" +
              this.activeSwiperIndex +
              this.swiperActiveSlideIndexes[this.activeSwiperIndex]
          );
          break;
        case KeySet.KEY_DOWN:
          if (this.activeSwiperIndex < this.genreSwipers.length - 1) {
            this.activeSwiperIndex++;
          }
          activeSlide = this.swiperActiveSlideIndexes[this.activeSwiperIndex];
          swiperVodList = this.getVodList();
          SpatialNavigation.focus(
            "#overlay" +
              this.activeSwiperIndex +
              this.swiperActiveSlideIndexes[this.activeSwiperIndex]
          );
          this.scrollFuncRef(
            "overlay" +
              this.activeSwiperIndex +
              this.swiperActiveSlideIndexes[this.activeSwiperIndex]
          );
          break;
        case KeySet.KEY_UP:
          if (this.activeSwiperIndex > 0) {
            this.activeSwiperIndex--;
            activeSlide = this.swiperActiveSlideIndexes[this.activeSwiperIndex];
            swiperVodList = this.getVodList();
            SpatialNavigation.focus(
              "#overlay" +
                this.activeSwiperIndex +
                this.swiperActiveSlideIndexes[this.activeSwiperIndex]
            );
            this.scrollFuncRef(
              "overlay" +
                this.activeSwiperIndex +
                this.swiperActiveSlideIndexes[this.activeSwiperIndex]
            );

            return;
          }
          setTimeout(() => {
            SpatialNavigation.resume();
          }, 100);

          if (this.getViewedVodType === VoDType.Movies) {
            SpatialNavigation.focus("#playBtn");
          } else {
            SpatialNavigation.focus("#favoritesBtn");
          }
          this.scrollFuncRef("favoritesBtn");
          break;
      }
    }
  }

  //return only genres of the selected VoD type that are populated with content
  get displayedVodExtraContent(): VoDGenre[] | Season[] {
    let filteredContent: VoDGenre[] | Season[] = [];
    switch (this.getViewedVodType) {
      case VoDType.Movies:
        this.getMoviesByGenre.forEach((vodGenre) => {
          if (
            vodGenre.latestMovies &&
            vodGenre.latestMovies.length > 0 &&
            this.vodItem &&
            this.vodItem.genres &&
            vodGenre.name === this.vodItem.genres[0].name
          ) {
            (filteredContent as VoDGenre[]).push(vodGenre);
          }
        });
        break;
      case VoDType.TvShows:
        filteredContent = (this.vodItem as TvShow).seasons!;
        break;
    }

    return filteredContent;
  }

  checkWindowWidth(): void {
    this.smallSwiper = window.innerWidth <= 1200;
  }

  getVodList(): Episode[] | Movie[] {
    if ("episodes" in this.displayedVodExtraContent[this.activeSwiperIndex]) {
      return (this.displayedVodExtraContent[this.activeSwiperIndex] as Season)
        .episodes;
    }

    return (this.displayedVodExtraContent[this.activeSwiperIndex] as VoDGenre)
      .latestMovies!;
  }

  @Watch("displayedVodExtraContent", { deep: true })
  handleVodCatUpdate(): void {
    this.initializeSwipers();
  }

  @Watch("getClosePlayer")
  @Watch("getShowEpisodeInfoModal")
  handleOverlayUpdate(): void {
    if (!this.getClosePlayer && !this.getShowEpisodeInfoModal) {
      EventBus.$emit("focusExtraContent");
      return;
    }

    if (this.getClosePlayer) {
      this.setPlayedEpisodePos({
        slideIndex: this.swiperActiveSlideIndexes[this.activeSwiperIndex],
        sliderIndex: this.activeSwiperIndex
      });
    }
  }

  beforeDestroy(): void {
    window.removeEventListener("resize", this.checkWindowWidth);
  }
}
